var _circle, _rect, _rect2, _path, _path2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3, _path4, _rect8, _rect9, _rect10, _rect11, _rect12, _path5, _path6, _rect13, _rect14, _rect15, _circle2, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoTransactionsQueued(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 280,
    viewBox: "0 0 340 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 171,
    cy: 140,
    r: 140,
    fill: "#24272E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 25,
    width: 258,
    height: 62,
    rx: 11,
    fill: "#1B2028"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 32,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1A2A42"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.75 49C32.75 48.5858 32.4142 48.25 32 48.25C31.5858 48.25 31.25 48.5858 31.25 49V49.3081C30.9233 49.3901 30.6026 49.5181 30.2973 49.6944C27.5755 51.2659 27.9214 55.2989 30.8711 56.3839L31.25 56.5232V61.2194C30.7151 61.0686 30.2373 60.717 29.9381 60.1988L29.5625 59.5483C29.3554 59.1895 28.8967 59.0666 28.538 59.2737C28.1792 59.4808 28.0563 59.9395 28.2634 60.2983L28.639 60.9488C29.2175 61.9507 30.1927 62.5796 31.25 62.7535V63C31.25 63.4142 31.5858 63.75 32 63.75C32.4142 63.75 32.75 63.4142 32.75 63V62.692C33.0768 62.61 33.3975 62.4819 33.7029 62.3056C36.4247 60.7341 36.0788 56.7011 33.1291 55.6161L32.75 55.4767L32.75 50.7805C33.285 50.9313 33.7629 51.283 34.0622 51.8013L34.4377 52.4518C34.6448 52.8105 35.1035 52.9334 35.4623 52.7263C35.821 52.5192 35.9439 52.0605 35.7368 51.7017L35.3612 51.0513C34.7827 50.0493 33.8074 49.4203 32.75 49.2465V49ZM31.0473 50.9934C31.1139 50.955 31.1815 50.9205 31.25 50.8897L31.25 54.9199C29.623 54.2014 29.4706 51.9037 31.0473 50.9934ZM32.9529 61.0066C32.8863 61.045 32.8185 61.0796 32.75 61.1104V57.08C34.3772 57.7984 34.5297 60.0962 32.9529 61.0066Z",
    fill: "#1573FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 45.25C26.0629 45.25 21.25 50.0629 21.25 56C21.25 61.9371 26.0629 66.75 32 66.75C37.9371 66.75 42.75 61.9371 42.75 56C42.75 50.0629 37.9371 45.25 32 45.25ZM22.75 56C22.75 50.8914 26.8914 46.75 32 46.75C37.1086 46.75 41.25 50.8914 41.25 56C41.25 61.1086 37.1086 65.25 32 65.25C26.8914 65.25 22.75 61.1086 22.75 56Z",
    fill: "#1573FE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 44,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#8B8B8B"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 60,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#505050"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 25,
    width: 258,
    height: 62,
    rx: 11,
    stroke: "#1A2A42",
    strokeWidth: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 193,
    width: 258,
    height: 62,
    rx: 11,
    fill: "#1B2028"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 200,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1A2A42"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.75 217C32.75 216.586 32.4142 216.25 32 216.25C31.5858 216.25 31.25 216.586 31.25 217V217.308C30.9233 217.39 30.6026 217.518 30.2973 217.694C27.5755 219.266 27.9214 223.299 30.8711 224.384L31.25 224.523V229.219C30.7151 229.069 30.2373 228.717 29.9381 228.199L29.5625 227.548C29.3554 227.19 28.8967 227.067 28.538 227.274C28.1792 227.481 28.0563 227.94 28.2634 228.298L28.639 228.949C29.2175 229.951 30.1927 230.58 31.25 230.753V231C31.25 231.414 31.5858 231.75 32 231.75C32.4142 231.75 32.75 231.414 32.75 231V230.692C33.0768 230.61 33.3975 230.482 33.7029 230.306C36.4247 228.734 36.0788 224.701 33.1291 223.616L32.75 223.477L32.75 218.781C33.285 218.931 33.7629 219.283 34.0622 219.801L34.4377 220.452C34.6448 220.81 35.1035 220.933 35.4623 220.726C35.821 220.519 35.9439 220.06 35.7368 219.702L35.3612 219.051C34.7827 218.049 33.8074 217.42 32.75 217.246V217ZM31.0473 218.993C31.1139 218.955 31.1815 218.92 31.25 218.89L31.25 222.92C29.623 222.201 29.4706 219.904 31.0473 218.993ZM32.9529 229.007C32.8863 229.045 32.8185 229.08 32.75 229.11V225.08C34.3772 225.798 34.5297 228.096 32.9529 229.007Z",
    fill: "#1573FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 213.25C26.0629 213.25 21.25 218.063 21.25 224C21.25 229.937 26.0629 234.75 32 234.75C37.9371 234.75 42.75 229.937 42.75 224C42.75 218.063 37.9371 213.25 32 213.25ZM22.75 224C22.75 218.891 26.8914 214.75 32 214.75C37.1086 214.75 41.25 218.891 41.25 224C41.25 229.109 37.1086 233.25 32 233.25C26.8914 233.25 22.75 229.109 22.75 224Z",
    fill: "#1573FE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 212,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#8B8B8B"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 228,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#505050"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 193,
    width: 258,
    height: 62,
    rx: 11,
    stroke: "#1A2A42",
    strokeWidth: 2
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 109,
    width: 258,
    height: 62,
    rx: 11,
    fill: "#1B2028"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 116,
    width: 48,
    height: 48,
    rx: 8,
    fill: "#1A2A42"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.75 133C112.75 132.586 112.414 132.25 112 132.25C111.586 132.25 111.25 132.586 111.25 133V133.308C110.923 133.39 110.603 133.518 110.297 133.694C107.575 135.266 107.921 139.299 110.871 140.384L111.25 140.523V145.219C110.715 145.069 110.237 144.717 109.938 144.199L109.562 143.548C109.355 143.19 108.897 143.067 108.538 143.274C108.179 143.481 108.056 143.94 108.263 144.298L108.639 144.949C109.217 145.951 110.193 146.58 111.25 146.753V147C111.25 147.414 111.586 147.75 112 147.75C112.414 147.75 112.75 147.414 112.75 147V146.692C113.077 146.61 113.398 146.482 113.703 146.306C116.425 144.734 116.079 140.701 113.129 139.616L112.75 139.477L112.75 134.781C113.285 134.931 113.763 135.283 114.062 135.801L114.438 136.452C114.645 136.81 115.104 136.933 115.462 136.726C115.821 136.519 115.944 136.06 115.737 135.702L115.361 135.051C114.783 134.049 113.807 133.42 112.75 133.246V133ZM111.047 134.993C111.114 134.955 111.182 134.92 111.25 134.89L111.25 138.92C109.623 138.201 109.471 135.904 111.047 134.993ZM112.953 145.007C112.886 145.045 112.819 145.08 112.75 145.11V141.08C114.377 141.798 114.53 144.096 112.953 145.007Z",
    fill: "#1573FE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112 129.25C106.063 129.25 101.25 134.063 101.25 140C101.25 145.937 106.063 150.75 112 150.75C117.937 150.75 122.75 145.937 122.75 140C122.75 134.063 117.937 129.25 112 129.25ZM102.75 140C102.75 134.891 106.891 130.75 112 130.75C117.109 130.75 121.25 134.891 121.25 140C121.25 145.109 117.109 149.25 112 149.25C106.891 149.25 102.75 145.109 102.75 140Z",
    fill: "#1573FE"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 128,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#8B8B8B"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 144,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#505050"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 109,
    width: 258,
    height: 62,
    rx: 11,
    stroke: "#1A2A42",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 261,
    cy: 230,
    r: 50,
    fill: "#1A2A42"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M247.937 209.671C248.584 209.154 248.689 208.21 248.171 207.563C247.654 206.916 246.71 206.811 246.063 207.329L241.063 211.329C240.416 211.846 240.311 212.79 240.829 213.437C241.346 214.084 242.29 214.189 242.937 213.671L247.937 209.671Z",
    fill: "#1573FE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M273.937 207.329C273.29 206.811 272.346 206.916 271.829 207.563C271.311 208.21 271.416 209.154 272.063 209.671L277.063 213.671C277.71 214.189 278.654 214.084 279.171 213.437C279.689 212.79 279.584 211.846 278.937 211.329L273.937 207.329Z",
    fill: "#1573FE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5 222C261.5 221.172 260.828 220.5 260 220.5C259.172 220.5 258.5 221.172 258.5 222L258.5 229C258.5 231.485 260.515 233.5 263 233.5H266C266.828 233.5 267.5 232.828 267.5 232C267.5 231.172 266.828 230.5 266 230.5H263C262.172 230.5 261.5 229.828 261.5 229L261.5 222Z",
    fill: "#1573FE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M260 208.5C248.126 208.5 238.5 218.126 238.5 230C238.5 241.874 248.126 251.5 260 251.5C271.874 251.5 281.5 241.874 281.5 230C281.5 218.126 271.874 208.5 260 208.5ZM241.5 230C241.5 219.783 249.783 211.5 260 211.5C270.217 211.5 278.5 219.783 278.5 230C278.5 240.217 270.217 248.5 260 248.5C249.783 248.5 241.5 240.217 241.5 230Z",
    fill: "#1573FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTransactionsQueued);
export default __webpack_public_path__ + "static/media/no-transactions-queued.5dda7a10b83adf76411b7e8e94e081cd.svg";
export { ForwardRef as ReactComponent };